module.exports = __webpack_public_path__ + "img/product_stepink.27d54142.png";